import { Pagination } from 'antd'
import styled from 'styled-components'

const StyledUnknownWordsModalPagination = styled(Pagination)`
  align-self: flex-end;
`

export default StyledUnknownWordsModalPagination
